import { JsonObject } from 'json2typescript';
import { TargetInterface } from '../interfaces/target.interface';

@JsonObject('Target')
export class Target implements TargetInterface {
  Description?: string;
  IconName?: string;
  Name?: string;
  Order?: number;
  ServiceModelCode?: string;
  SimulationType?: string;
  Type?: string;
  TypeObject?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
